module.exports = __webpack_public_path__ + "media/6.122d9a5e.wav";